import React, { useState, useEffect } from "react";
import playBadge from "../../assets/images/google-play-badge.svg";
import appleBadge from "../../assets/images/app-store-badge.svg";

const ANDROID_URL = "https://play.google.com/store/apps/details?id=com.gigfalcon";
const IOS_URL = "https://apps.apple.com/us/app/gig-falcon/id6499023603";


const isMobile = () => {
  if (typeof window === "undefined") return false;
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );
};

const getMobileOS = () => {
  if (typeof window === "undefined") return null;
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  console.log("User Agent:", ua);
  if (/android/i.test(ua)) return "android";
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "ios";
  return null;
};

const DownloadAppSlider = () => {
  const [visible, setVisible] = useState(false);
  const [os, setOS] = useState(null);

  useEffect(() => {
    if (isMobile()) {
      setOS(getMobileOS());
      console.log("Mobile OS detected:", getMobileOS());
    //   if (!sessionStorage.getItem("hideDownloadAppSlider")) {
    setTimeout(() => {
        setVisible(true);
    }, 1000);
    }
  }, []);

  const handleClose = () => {
    setVisible(false);
    // sessionStorage.setItem("hideDownloadAppSlider", "1");
  };

  if (!os) return null;

  return (
    <div
      className={`position-fixed w-100 d-flex justify-content-between align-items-center download-app-slider ${visible ? 'show' : ''}`}
      style={{
        left: 0,
        bottom: 0,
        zIndex: 9999,
        pointerEvents: visible ? 'auto' : 'none',
        fontSize: '13px',
      }}
    >
      <div className="d-flex align-items-center justify-content-between  gap-3 p-1 rounded shadow border w-100" style={{backgroundColor:'#11d3bce0',}}>
        <span className="fw-bold">Download the GigFalcon App!</span>
        <a
          href={os === "android" ? ANDROID_URL : IOS_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          {os === "android" ? (
            <img
              src={playBadge}
              alt="Get it on Google Play"
              style={{ height: 32 }}
            />
          ) : (
            <img
              src={appleBadge}
              alt="Download on the App Store"
              style={{ height: 32 }}
            />
          )}
        </a>
        <button
          className="btn btn-sm ms-2 fs-5"
          onClick={handleClose}
          aria-label="Close download app slider"
        >
          &times;
        </button>
      </div>
      <style>{`
        .download-app-slider {
          transition: transform 0.4s cubic-bezier(.4,0,.2,1);
          transform: translateY(100%);
        }
        .download-app-slider.show {
          transform: translateY(0);
          pointer-events: auto;
        }
      `}</style>
    </div>
  );
};

export default DownloadAppSlider;
